import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import Helmet from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';
import { DataProvider } from './backend/firebase';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
     <BrowserRouter>
    {/* <ScrollToTop /> */}
    <Helmet>
        <style>{'body { background-color: #151515; }'}</style>
    </Helmet>
  <DataProvider>
    <App />
  </DataProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//#15212B